<!-- <div id="distanceChart"></div> -->
<nz-drawer
  [nzWidth]="'60%'"
  [nzClosable]="true"
  [nzVisible]="visible"
  nzPlacement="right"
  nzTitle="Vehicle Dashboard"
  (nzOnClose)="visible = false"
>
  <ng-container *nzDrawerContent>
    @if (selectedVehicle) {
    <app-vehicle-slider [vechile]="selectedVehicle"></app-vehicle-slider>
    }
  </ng-container>
</nz-drawer>
<!-- <div class="dashbSlider" *ngIf="visible">
<button type="button" class="slider-close-btn" (click)="closeVehicleSlider()" aria-label="Close slider">
  <i nz-icon nzType="right" nzTheme="outline"></i>
</button>
<app-vehicle-slider [vechile]="selectedVehicle" *ngIf="selectedVehicle"></app-vehicle-slider>
</div> -->

<nz-layout class="rmv_mrgn">
  <nz-layout>
    <nz-content>
      <div class="inner-content">
        @if (opnSdebar == true) {
        <button nz-button (click)="closeSidebar()" class="sdNavBtn rt-4h">
          <!-- <i nz-icon nzType="filter" nzTheme="outline"></i> -->
          Close
        </button>
        } @if (opnSdebar == false) {
        <button nz-button (click)="openSidebar()" class="sdNavBtn2 rt-40">
          <i nz-icon nzType="filter" nzTheme="outline"></i>Filters
        </button>
        }
        <div id="livemap">
          <div class="vhcl-sts-card">
            <ul>
              <li>
                <span class="greenCls" style="height: 12px; width: 12px"></span>
                Running
              </li>
              <li>
                <span class="blueCls" style="height: 12px; width: 12px"></span>
                Stationed for < 5Min
              </li>
              <li>
                <span
                  class="yellowCls"
                  style="height: 12px; width: 12px"
                ></span>
                Stationed for 5Min - 15Min
              </li>
              <li>
                <span class="redCls" style="height: 12px; width: 12px"></span>
                Stationed for > 15Min
              </li>
              <li><span class="greyCls"></span> Offline Vehicles</li>
            </ul>
          </div>
        </div>
      </div>
    </nz-content>
  </nz-layout>

  @if (opnSdebar == true) {
  <nz-sider
    nzCollapsible
    [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null"
    class="sdr"
  >
    <h2 class="sdHdr">
      Live tracking
      <span
        nz-icon
        nzType="close-circle"
        nzTheme="outline"
        style="float: right; margin-top: 3px"
        (click)="closedrvrlst()"
      ></span>
    </h2>
    @if (shwMrkerDta) {
    <div class="lvtFrm">
      <div class="row mg-b6">
        <div class="col-lg-4 col-md-4">
          <nz-form-label>Vehicle Number</nz-form-label>
        </div>
        <div class="col-lg-1 col-md-1 hdemblvw">
          <nz-form-label>:</nz-form-label>
        </div>
        <div class="col-lg-7 col-md-7">
          <nz-form-label>AP Z2 3533</nz-form-label>
        </div>
      </div>
      <div class="row mg-b6">
        <div class="col-lg-4 col-md-4">
          <nz-form-label>Vehicle Group</nz-form-label>
        </div>
        <div class="col-lg-1 col-md-1 hdemblvw">
          <nz-form-label>:</nz-form-label>
        </div>
        <div class="col-lg-7 col-md-7">
          <nz-form-label>Health</nz-form-label>
        </div>
      </div>
      <div class="row mg-b6">
        <div class="col-lg-4 col-md-4">
          <nz-form-label>Vehicle Category</nz-form-label>
        </div>
        <div class="col-lg-1 col-md-1 hdemblvw">
          <nz-form-label>:</nz-form-label>
        </div>
        <div class="col-lg-7 col-md-7">
          <nz-form-label>Compactor-Big (Running)</nz-form-label>
        </div>
      </div>
      <div class="row mg-b6">
        <div class="col-lg-4 col-md-4">
          <nz-form-label>Current Area</nz-form-label>
        </div>
        <div class="col-lg-1 col-md-1 hdemblvw">
          <nz-form-label>:</nz-form-label>
        </div>
        <div class="col-lg-7 col-md-7">
          <nz-form-label>NA</nz-form-label>
        </div>
      </div>
      <div class="row mg-b6">
        <div class="col-lg-4 col-md-4">
          <nz-form-label>Current Location</nz-form-label>
        </div>
        <div class="col-lg-1 col-md-1 hdemblvw">
          <nz-form-label>:</nz-form-label>
        </div>
        <div class="col-lg-7 col-md-7">
          <nz-form-label>NA</nz-form-label>
        </div>
      </div>
      <div class="row mg-b6">
        <div class="col-lg-4 col-md-4">
          <nz-form-label>Driver Name</nz-form-label>
        </div>
        <div class="col-lg-1 col-md-1 hdemblvw">
          <nz-form-label>:</nz-form-label>
        </div>
        <div class="col-lg-7 col-md-7">
          <nz-form-label>Not Assigned</nz-form-label>
        </div>
      </div>
      <div class="row mg-b6">
        <div class="col-lg-4 col-md-4">
          <nz-form-label>Driver Phone number</nz-form-label>
        </div>
        <div class="col-lg-1 col-md-1 hdemblvw">
          <nz-form-label>:</nz-form-label>
        </div>
        <div class="col-lg-7 col-md-7">
          <nz-form-label>Not Assigned</nz-form-label>
        </div>
      </div>
      <div class="row mg-b6">
        <div class="col-lg-4 col-md-4">
          <nz-form-label>Stoppage Time</nz-form-label>
        </div>
        <div class="col-lg-1 col-md-1 hdemblvw">
          <nz-form-label>:</nz-form-label>
        </div>
        <div class="col-lg-7 col-md-7">
          <nz-form-label>Not Assigned</nz-form-label>
        </div>
      </div>
      <!-- <div class="row mg-b6">
            <div class="col-lg-3 col-md-3"></div>
            <div class="col-lg-6 col-md-6">
              <button nz-button nzType="primary" nzBlock>Get Directions</button> -->
      <!-- </div>
            <div class="col-lg-3 col-md-3"></div>
          </div> -->
      <div style="text-align: center; margin-top: 10px">
        <h6>------ Daywise Distance Covered Status ------</h6>
        <div id="distanceChart"></div>
      </div>
      <div style="text-align: center; margin-top: 10px">
        <h6>------ Daywise Trip Covered Status ------</h6>
        <div id="tripChart"></div>
      </div>
    </div>
    } @if (shwDta) {
    <div class="lvtFrm">
      <form nz-form [formGroup]="livetrackform">
        <div class="row mg-b6">
          <div class="col-lg-4 col-md-4 fs_11">
            @if (clntDtls[0].clnt_id==3000000) {
            <nz-form-label nzRequired>District</nz-form-label>
            } @if (clntDtls[0].clnt_id==7) {
            <nz-form-label nzRequired>Show ULB/Mandal</nz-form-label>
            } @if (clntDtls[0].clnt_id!=7 && clntDtls[0].clnt_id!=3000000 &&
            clntDtls[0].clnt_id!=3000001) {
            <nz-form-label nzRequired>Show ULB</nz-form-label>
            } @if (clntDtls[0].clnt_id==3000001) {
            <nz-form-label nzRequired>Zone</nz-form-label>
            }
          </div>
          <div class="col-lg-1 col-md-1 hdemblvw">
            <nz-form-label>:</nz-form-label>
          </div>
          <div class="col-lg-7 col-md-7">
            <nz-form-item>
              <nz-form-control>
                <nz-select
                  nzShowSearch
                  class="slctBx"
                  [(ngModel)]="selectedtenants"
                  (ngModelChange)="ontntSelects($event)"
                  [ngModelOptions]="{ standalone: true }"
                >
                  @if (showAll) {
                  <nz-option [nzLabel]="'Select All'" [nzValue]="0"></nz-option>
                  }
                  <!-- <nz-option [nzLabel]="'Deselect All'" [nzValue]="1"></nz-option> -->
                  @for (t of tntLst; track t) {
                  <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_nm">
                  </nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="row mg-b6">
          <div class="col-lg-4 col-md-4 fs_11">
            <nz-form-label nzRequired>Select {{ grpLbl }}</nz-form-label>
          </div>
          <div class="col-lg-1 col-md-1 hdemblvw">
            <nz-form-label>:</nz-form-label>
          </div>
          <div class="col-lg-7 col-md-7">
            <nz-form-item>
              <nz-form-control>
                <nz-select
                  nzShowSearch
                  nzAllowClear
                  nzPlaceHolder="Please select VehicleGroup"
                  formControlName="vhcl"
                  (ngModelChange)="getCatLists($event)"
                >
                  <nz-option
                    [nzLabel]="'Select All'"
                    [nzValue]="'select'"
                  ></nz-option>
                  <!-- <nz-option [nzLabel]="'Deselect All'" [nzValue]="'deselect'"></nz-option> -->
                  @for (v of assrtGroupList; track v) {
                  <nz-option
                    [nzLabel]="v.asrt_grp_nm"
                    [nzValue]="v.asrt_grp_id"
                  ></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        @if (ShowClap) {
        <div class="row mg-b6">
          <div class="col-lg-4 col-md-4 fs_11">
            <nz-form-label nzRequired>Show Vehicle Vendor</nz-form-label>
          </div>
          <div class="col-lg-1 col-md-1 hdemblvw">
            <nz-form-label>:</nz-form-label>
          </div>
          <div class="col-lg-7 col-md-7">
            <nz-form-item>
              <nz-form-control>
                <nz-select
                  class="slctBx"
                  nzShowSearch
                  [(ngModel)]="selectedvndr"
                  (ngModelChange)="onvndrSelect($event)"
                  [ngModelOptions]="{ standalone: true }"
                >
                  @if (!showVndr) {
                  <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
                  } @for (v of vendorList; track v) {
                  <nz-option [nzValue]="v.vndr_id" [nzLabel]="v.vndr_nm">
                  </nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        }
        <div class="row mg-b6">
          <div class="col-lg-4 col-md-4 fs_11">
            <nz-form-label nzRequired>Show Location Group</nz-form-label>
          </div>
          <div class="col-lg-1 col-md-1 hdemblvw">
            <nz-form-label>:</nz-form-label>
          </div>
          <div class="col-lg-7 col-md-7">
            <nz-form-item>
              <nz-form-control>
                <nz-select
                  [nzMaxTagCount]="2"
                  nzPlaceHolder="Please select Location group"
                  [(ngModel)]="locModel"
                  (ngModelChange)="onLocationSelect($event)"
                  formControlName="lctn"
                >
                  @for (l of activeGroups; track l) {
                  <nz-option
                    [nzLabel]="l.fnce_grp_nm"
                    [nzValue]="l.fnce_grp_id"
                  >
                  </nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="row mg-b6">
          <div class="col-lg-4 col-md-4 fs_11">
            <nz-form-label nzRequired>Show Locations</nz-form-label>
          </div>
          <div class="col-lg-1 col-md-1 hdemblvw">
            <nz-form-label>:</nz-form-label>
          </div>
          <div class="col-lg-7 col-md-7">
            <nz-form-item>
              <nz-form-control>
                <nz-select
                  [nzMaxTagCount]="2"
                  nzPlaceHolder="Please select Location"
                  [(ngModel)]="fnclocModel"
                  (ngModelChange)="getLocOnMap()"
                  formControlName="lctnFnce"
                >
                  <nz-option
                    [nzLabel]="'Select All'"
                    [nzValue]="'select'"
                  ></nz-option>
                  <nz-option
                    [nzLabel]="'Deselect All'"
                    [nzValue]="'deselect'"
                  ></nz-option>
                  @for (l of fncsLst; track l) {
                  <nz-option [nzLabel]="l.fnce_nm" [nzValue]="l.fnce_id">
                  </nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        @if (clap_in==0) {
        <div class="row mg-b6">
          <div class="col-lg-4 col-md-4 fs_11">
            <nz-form-label nzRequired>Select Vehicle Category</nz-form-label>
          </div>
          <div class="col-lg-1 col-md-1 hdemblvw">
            <nz-form-label>:</nz-form-label>
          </div>
          <div class="col-lg-7 col-md-7">
            <nz-form-item>
              <nz-form-control>
                <nz-select
                  nzShowSearch
                  nzAllowClear
                  nzPlaceHolder="Please select VehicleCategory"
                  formControlName="ctrgy"
                  (ngModelChange)="getTypeList($event)"
                >
                  <nz-option
                    [nzLabel]="'Select All'"
                    [nzValue]="'select'"
                  ></nz-option>
                  <!-- <nz-option [nzLabel]="'Deselect All'" [nzValue]="'deselect'"></nz-option> -->
                  @for (t of asrtCtgryList; track t) {
                  <nz-option
                    [nzLabel]="t.asrt_ctgry_nm"
                    [nzValue]="t.asrt_ctgry_id"
                  ></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        }
        <!-- <div class="input-row" nz-row>
            <div nz-col nzFlex="2">
              <nz-form-label>Select VehcileType</nz-form-label>
            </div>
            <div nz-col nzFlex="3">
              <nz-form-item>
                <nz-form-control>
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Please select Trip" formControlName="typ" (ngModelChange)="getAssertList()">
                    <nz-option *ngFor="let p of asrtTypeList" [nzLabel]="p.asrt_type_id" [nzValue]="p.asrt_type_nm"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>  -->
      </form>
      @if (usrDtls?.rle_id==4000001) {
      <div class="vehicle-status-tabs">
        <div class="custom-tab-row">
          <div
            class="custom-tab"
            [class.active]="seletedIndex === 0"
            (click)="tabchange({ index: 0 })"
            [style.background]="
              tabs[0].actv_in == 1 ? tabs[0].actv_bg_clr : tabs[0].bg_clr
            "
            [style.color]="tabs[0].actv_in == 1 ? '#fff' : tabs[0].clr"
          >
            <p [style.color]="tabs[0].actv_in == 1 ? '#fff' : tabs[0].clr">
              {{ tabs[0].cnt }}
            </p>
            <div class="tab-content">
              <i nz-icon [nzType]="tabs[0].icon" nzTheme="outline"></i>
              <span class="tab-name">{{ tabs[0].name }}</span>
            </div>
          </div>
          <div
            class="custom-tab"
            [class.active]="seletedIndex === 1"
            (click)="tabchange({ index: 1 })"
            [style.background]="
              tabs[1].actv_in == 1 ? tabs[1].actv_bg_clr : tabs[1].bg_clr
            "
            [style.color]="tabs[1].actv_in == 1 ? '#fff' : tabs[1].clr"
          >
            <p [style.color]="tabs[1].actv_in == 1 ? '#fff' : tabs[1].clr">
              {{ tabs[1].cnt }}
            </p>
            <div class="tab-content">
              <i nz-icon [nzType]="tabs[1].icon" nzTheme="outline"></i>
              <span class="tab-name">{{ tabs[1].name }}</span>
            </div>
          </div>
        </div>
      </div>
      } @if (usrDtls?.rle_id!=4000001) {
      <div class="vehicle-status-tabs">
        <!-- First row of tabs (0-3) -->
        <nz-tabs
          nzType="card"
          [nzSelectedIndex]="seletedIndex < 5 ? seletedIndex : 0"
          class="tab-row"
        >
          @for (tab of tabs.slice(0, 5); track tab; let i = $index) {
          <nz-tab [nzTitle]="titleTemplate1">
            <ng-template #titleTemplate1>
              <div
                class="tbDv"
                (click)="tabchange({ index: i })"
                [ngStyle]="
                  tab.actv_in == 1
                    ? { background: tab.actv_bg_clr, color: '#fff' }
                    : { background: tab.bg_clr, color: tab.clr }
                "
              >
                <p
                  [ngStyle]="
                    tab.actv_in == 1 ? { color: '#fff' } : { color: tab.clr }
                  "
                >
                  {{ tab.cnt }}
                </p>
                <div class="tab-content">
                  <i nz-icon [nzType]="tab.icon" nzTheme="outline"></i>
                  <span class="tab-name">{{ tab.name }}</span>
                </div>
              </div>
            </ng-template>
          </nz-tab>
          }
        </nz-tabs>
        <!-- Second row of tabs (4-7) -->
        <nz-tabs
          nzType="card"
          [nzSelectedIndex]="seletedIndex >= 5 ? seletedIndex - 5 : 0"
          class="tab-row"
        >
          @for (tab of tabs.slice(5, 9); track tab; let i = $index) {
          <nz-tab [nzTitle]="titleTemplate2">
            <ng-template #titleTemplate2>
              <div
                class="tbDv"
                (click)="tabchange({ index: i + 5 })"
                [ngStyle]="
                  tab.actv_in == 1
                    ? { background: tab.actv_bg_clr, color: '#fff' }
                    : { background: tab.bg_clr, color: tab.clr }
                "
              >
                <p
                  [ngStyle]="
                    tab.actv_in == 1 ? { color: '#fff' } : { color: tab.clr }
                  "
                >
                  {{ tab.cnt }}
                </p>
                <div class="tab-content">
                  <i nz-icon [nzType]="tab.icon" nzTheme="outline"></i>
                  <span class="tab-name">{{ tab.name }}</span>
                </div>
              </div>
            </ng-template>
          </nz-tab>
          }
        </nz-tabs>
      </div>
      }
      <!-- <div class="ds-card grid lvtrcktbl"> -->
      <app-data-grid
        id="gridContainer"
        class="lvetracktable"
        [dataSource]="stslist"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="false"
        [columnChooser]="false"
        [allowExport]="false"
        [pageSize]="10"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [wordWrapEnabled]="true"
        (rowClick)="getEahVehicle($event)"
      >
        <!-- -->
        <app-grid-column
          dataField="sno"
          caption="S.No"
          width="45"
          alignment="center"
        ></app-grid-column>
        <app-grid-column
          dataField="asrt_nm"
          caption="Vehicle"
          alignment="center"
          width="90"
        ></app-grid-column>
        <app-grid-column
          dataField="asrt_sts_nm"
          dataType="string"
          caption="Status"
          cellTemplate="stsTemplate"
          alignment="center"
        ></app-grid-column>
        <app-grid-column
          dataField="asrt_ctgry_nm"
          caption="Category"
          width="120"
          alignment="left"
        ></app-grid-column>
        <app-grid-column
          dataField="tdy_dst"
          caption="Distance"
          alignment="center"
          width="80"
        ></app-grid-column>
        <ng-template appGridCell="stsTemplate" let-d="cell"
          ><div>
            <div [ngStyle]="{ color: d.row.data.clr_cd }">
              <!-- <span><i nz-icon [nzType]="d.row.data.icn_txt" nzTheme="outline"></i></span> -->
              <!-- <span style="padding-left: 5px;text-transform: uppercase;">{{d.row.data.asrt_sts_nm}}</span> -->
              <span
                ><img
                  src="assets/images/markers/mapIcons/m/sgnl_{{
                    d.row.data.sgnl_strngth_ct
                  }}.png"
                  alt=""
                />
              </span>
              <span
                ><img
                  src="assets/images/markers/mapIcons/m/igntn_{{
                    d.row.data.igntn_in
                  }}.png"
                  alt=""
                />
              </span>
              <span style="margin-right: 8px"
                ><img
                  src="assets/images/markers/mapIcons/m/chrg_{{
                    d.row.data.chrg_in
                  }}.png"
                  alt=""
                />
              </span>
              <span
                [ngClass]="
                  d.row.data.spd_ct > 0 && d.row.data.diffTimeInMin < 5
                    ? 'greenCls'
                    : d.row.data.spd_ct >= 0 && d.row.data.diffTimeInMin <= 5
                    ? 'blueCls'
                    : d.row.data.spd_ct >= 0 &&
                      d.row.data.diffTimeInMin >= 5 &&
                      d.row.data.diffTimeInMin < 15
                    ? 'yellowCls'
                    : 'redCls'
                "
              ></span>
              <!-- <span *ngIf="diffTimeInMin >= 60 && diffTimeInHrs < 24" style="background-color: yellow;">&nbsp;{{diffTimeInMin}}<span>Min</span></span>
              <span *ngIf="diffTimeInMin >= 24 && diffTimeInDys > 0" style="background-color: red;">&nbsp;{{diffTimeInMin}}<span>Min</span></span> -->
            </div>
          </div></ng-template
        >
      </app-data-grid>
      <!-- </div> -->
    </div>
    }
  </nz-sider>
  }
</nz-layout>
